import React from "react";
import { useLanguage } from "../../context/LanguageContext";

const ProfileModal = ({ title, onClose, children, descriptionId, className = "" }) => {
  const { t } = useLanguage();

  return (
    <div
      className={`profile-modal${className ? ` ${className}` : ""}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="profile-modal-title"
      aria-describedby={descriptionId}
    >
      <div className="profile-modal__scrim" onClick={onClose} />
      <div className="profile-modal__content" role="document">
        <header className="profile-modal__header">
          <h3 id="profile-modal-title">{title}</h3>
          <button
            type="button"
            className="profile-modal__close"
            onClick={onClose}
            aria-label={t("profilePage.actions.closeDialog", "Close dialog")}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </header>
        <div className="profile-modal__body">{children}</div>
      </div>
    </div>
  );
};

export default ProfileModal;
